export default "<app-loader [isLoading]=\"showLoader\"></app-loader>\n";